export const UI_VERSION = '9.1.4';
